export const property = {
  gamefi: "GameFi",
  mc_official_verify_unofficial: "未確認のソース",
  mc_official_verify_official: "公式",
  mc_official_verify_fotter_tip_1:
    "Biking社員のなりすましによるオンライン/電話詐欺を防止するためのリスクリマインダー",
  mc_official_verify_fotter_tip_2: "Biking、不正行為防止のためのリスク警告",
  mc_official_verify_modal_tip_1:
    "お問い合わせの [{query}] はBikingの公式チャンネルであることが確認されました",
  mc_official_verify_modal_tip_3:
    "入力された情報およびフォーマットが正しいかどうかご確認ください：",
  mc_official_verify_modal_tip_4: "携帯電話番号：xx-xxxxxxxxxx",
  mc_official_verify_modal_type_email: "メールアドレス",
  mc_official_verify_modal_type_domain: "ドメイン",
  mc_official_verify_modal_type_channel: "チャネル",
  mc_official_verify_input_placeholder:
    "検証のため、情報およびフォーマットを正しく入力してください",
  mc_official_verify_head_title: "Biking取引所公式検証チャネル | Biking取引所",
  mc_official_verify_head_description: "Biking取引所の公式検証チャネル",
  mc_official_verify_title: "Biking検証",
  mc_official_verify_discription_new:
    "本ページでは、URL、メールアドレス、電話番号、またXやTelegramなどのソーシャルメディアアカウントが、検証済みのBiking公式ソースであるかどうかを確認することができます。これにより、フィッシングやオンライン詐欺による資産の損失を防ぐのに役立ちます。",
  mc_official_verify_fotter_tip_3:
    "Bikingユーザー必読の詐欺防止マニュアル：詐欺の拡大に注意してください！",
  mc_unofficial_verify_modal_tip_1:
    "あなたの検索 [{{query}] は検証済みのBiking公式ソースではありません",
  mc_official_verify_discription:
    "Bikingの名を騙った詐欺を防ぐため、電話番号や X、Facebook、Telegram、WeChatなどのアカウントが、Biking公式のものであるかご確認いただけます。",
  mc_official_head_title1: "Bikingの公式チャンネル、ニュース、出版物の確認",
  mc_official_head_keywords1:
    "Biking検証、Bikingニュース、Biking公式アカウント",
  mc_official_head_description1:
    "Bikingチャネルの信頼性を確認。公式検証ツールを使用してBikingに関連するチャネル、ニュース、出版物の正当性を確認してください。",
  mc_official_verify_verified_title: "検証済みの公式ソース",
  mc_official_verify_modal_tip_5:
    "Telegram/X/Facebook/Youtube：@xxxxx (@マーク付き)",
  mc_official_verify_modal_tip_6: "TikTok/Instagram：xxxx (@マークなし)",
  mc_official_verify_modal_tip_7: "Discord：xxxx#xxxx (@マークなし)",
  mc_official_verify_modal_tip_8:
    "LinkedIn/Telegramグループ/Medium/Reddit：https://xxxxx (ウェブサイトリンク)",
  mc_official_verify_modal_tip_9:
    "フォーマットについてご質問がありましたら、お気軽にカスタマーサービスまでお問い合わせください。",
  mc_official_verify_modal_tip_10:
    "* アカウント情報およびパスワードを誰にも開示しないでください。",
  mc_official_verify_modal_tip_11: "* 詐欺に注意し、慎重に操作してください。",
  tagtip:"入金プラットフォームがコメントの入力を求めていない場合、この項目は空白のままにしてください。",
  tagtip1:"タグは特定のアカウントまたはユーザーを識別するための固有コードで、資金が正しい受取人に送信されることを保証します。",
  tagtip2:"他の取引プラットフォームやウォレットでは、タグをデジタル ID、タグ、メモ、注記、備考などと呼ぶ場合があります。",
  tag: "コメントを入力してください",
  qbcbcg:
    "成功した入金を確実にするために、TONアドレスとコメントを一緒にコピーしてください。",
  qsrzqje: "正しい金額を入力してください",
  games: "ゲームアカウント",
  cbxz: "Ethereum（ERC20）デポジットの注意事項",
  tbxz: "Ethereum（ERC20）引き出しに関する注意事項",
  ctbzysx:
    "注意：公式のFUFUスマートコントラクトからの各送金には追加で2％の手数料がかかります。",
  dzcw: "アドレスエラー",
  czqkqrs: "入金ブロック確認数",
  mc: "名称",
  cjsj: "作成日時",
  lx: "タイプ",
  sl: "数量",
  cwjl: "資金履歴",
  ylzh: "利益",
  ddtx: "出金待ち",
  txcg: "出金成功",
  yhcx: "ユーザーキャンセル",
  qbcbjl: "全ての入金履歴",
  zczl: "資産一覧",
  zjzh: "資金口座",
  mbzh: "コイン購入口座",
  xhzh: "現物口座",
  hyzh: "先物取引口座",
  lczh: "金融口座",
  gdzh: "コピードレート口座",
  giftzh: "ボーナス口座",
  bwzh: "ビーキングカード",
  mozh: "デモ口座",
  mnhy: "模擬契約",
  sxffy: "システムコミッション",
  kt: "エアドロップ",
  xtkc: "システム控除",
  zcfb: "資産分布",
  zcdt: "資産状態",
  zh: "口座",
  zc: "資産",
  czjl: "入金履歴",
  txls: "出金履歴",
  hzjl: "振替履歴",
  mmjl: "売買履歴",
  cb: "入金",
  tx: "出金",
  hz: "振替",
  mb: "購入",
  jy: "取引",
  zwsj: "データなし",
  ckqb: "全て見る",
  // table
  bz: "通貨",
  qc: "全称",
  zhze: "口座総額",
  syzc: "利用可能資産",
  djzc: "凍結資産",
  cz: "操作",
  sl: "数量",
  cbdz: "入金アドレス",
  sj: "時間",
  zt: "ステータス",
  ms: "説明",
  hzfx: "振替方向",
  hzse: "振替金額",
  txdz: "出金アドレス",
  sxf: "手数料",
  ddh: "注文番号",
  zj: "総価格",
  dj: "単価",
  jysl: "取引数量",
  jydx: "取引相手",
  zhqy: "口座資産",
  zhqytips: "口座資産 = 利用可能証拠金 + ポジション証拠金",
  kybzj: "利用可能証拠金",
  kybzjtips: "ポジション取得のためと振替に使用可能な証拠金",
  cwbzj: "ポジション証拠金",
  cwbzjtips: "既存のポジションを維持するための証拠金",
  // search
  srbz: "該当通貨を入力してください",
  ycxzc: "小額資産を非表示",
  sy: "すべて",
  qb: "全て",
  qx: "全て",
  zhi: "まで",
  ksrq: "開始日",
  jsrq: "終了日",
  cx: "検索",
  dc: "エクスポート",
  zjqt: "過去7日間",
  zjygy: "過去1ヶ月",
  qbsj: "全ての時間",
  usdt: "USDT",
  ddlx: "注文タイプ",
  gm: "購入",
  cs: "売却",
  // recharge
  czxq: "入金詳細",
  usdtcbjl: "{coinName}入金履歴",
  cbsl: "入金数量",
  cbzt: "入金状態",
  crdbz: "入金通貨を選択してください",
  tqdbz: "出金通貨を選択してください",
  rmbz: "人気通貨",
  qxz: "選択してください",
  cbwl: "入金ネットワーク",
  cbtips:
    "入金ネットワークが出金プラットフォームと一致していることを確認してください。そうでない場合、資産が失われる可能性があります。",
  txfs: "出金方法",
  lstx: "チェーン上の出金",
  xyb: "次へ",
  yxzdq: "現在選択中の通貨は",
  dbz: "の通貨です",
  cxxz: "再度選択",
  dzkbz:
    "アドレスライブラリのアドレスが不足しています。管理者に連絡してください。",
  qxzcrdbz: "入金通貨を選択してください",
  qxzcbwl: "入金ネットワークを選択してください",
  qxztqdbz: "出金通貨を選択してください",
  cr: "入金",
  tq: "出金",
  cbxq: "入金詳細",
  txxq: "出金詳細",
  usdttxjl: "{coinName}出金履歴",
  qbtxjl: "全ての出金履歴",
  zyxx: "重要な情報：このアドレスには{coinName}しか送ることができません。他の暗号通貨を送ると、資金が失われる可能性があります。",
  jzjcr: "資金を入金",
  smewm:
    "QRコードをスキャンするか、以下の情報をコピーして送信プラットフォームに貼り付けてください。",
  xcdzcz:"このアドレスには、他のタイプの通貨を送らないでください。それ以外の場合、資産が取り戻せなくなります。",
  xcdzczss:"XRP を入金する際は必ずタグをコピーしてください。そうしないと資金が失われる可能性があります。",
  znhycz:
    "現在、スマートコントラクトの入金、パッケージ入金、ブロック報酬入金はサポートされていません。",
  usdtcbdz: "{coinName}入金アドレス",
  fzdz: "アドレスをコピー",
  usdtdz: "{coinName}アドレス",
  zxcbe: "最小入金額",
  zytx2:
    "重要な情報：送信プラットフォームが選択した{coinName}ネットワークをサポートしていることを確認してください。そうでない場合、資金が失われる可能性があります。",
  kytxwl: "{coinName}利用可能な出金ネットワーク",
  xzwl: "ネットワークを選択",
  dzym: "{coinName} アドレス",
  srdz: "アドレスを入力するか、アドレス帳から選択してください",
  jymm: "取引パスワード",
  qsrjymm: "取引パスワードを入力してください",
  zxtbe: "最小出金額：{minAmount}",
  ky: "利用可能：",
  zhztbxe: "口座総出金制限額",
  gjxyddj:
    "あなたの認証レベルに基づき、24時間以内に出金できる金額が制限されます。この制限額はUSDを選択した暗号通貨に変換して計算されます。",
  scbdjd:
    "通貨価格の変動が大きいため、通貨の手数料は変動手数料となります。過去24時間の平均通貨価格に基づいて、相当する0.2-0.2 USDTの手数料を請求し、手数料を増やして出金速度を向上させます。",
  yqdz: "予想出金額",
  yqdzwf: "予想出金額は負数にできません",
  sfrz: "本人確認",
  ggyzm: "Google認証コード",
  dxyzm: "SMS認証コード",
  yxyzm: "メール認証コード",
  qsryzm: "認証コードを入力してください",
  fsyzm: "送信",
  cxfs: "再送信",
  tj: "提出",
  qxztxwl: "出金ネットワークを選択してください",
  qsrdz: "アドレスを入力してください",
  qxzdz: "アドレスを選択してください",
 qxzyzfs: "認証方法を選択してください",
 qsrtqsl: "抽出する数量を入力してください",
 qwcyz: "検証を完了してください",
 qqrbdsj: "まず携帯電話をバインドするかどうかを確認してください",
 qqrbdyx: "まずメールアドレスをバインドするかどうかを確認してください",
 fzcg: "コピー成功しました!",
 tbcg: "引き出しに成功しました",
 usdttxdz: "{coinName} 出金アドレス",
 lmc: "チェーン名:",
 qtj: "*追加してください",
 dz: "アドレス",
 fei: "非",
 zjds: "このアドレスは資産損失を引き起こす可能性があります",
 yzfs: "検証方法",
 yzm: "確認コード",
 remark: "備考",
 qsrremark: "コメントを入力してください",
 tjdzcg: "アドレスが正常に追加されました",
 qxxzyzfs: "まず検証方法を選択してください",
 qsrtxdz: "出金アドレスを入力してください",
  stop: "一時停止",
  // status
  qr0: "0確認",
  qr1: "1確認",
  dqr: "確認待ち",
  czcg: "入金成功",
  hzz: "振替中",
  ywc: "処理完了",
  sb: "失敗",
  zzcl: "処理中",
  ddsh: "処理待ち",
  txcg: "出金成功",
  cxcg: "キャンセル成功",
  ddtx: "出金待ち",
  txsb: "出金失敗",
  slsb: "チェーンエラー",
  dfk: "支払い待ち",
  yfk: "支払い済み",
  yqx: "キャンセル済み",
  ssz: "申し立て中",
  gdfrhz: "コピー取引利益分配振替",
  hyzh_to_gdzh: "先物取引口座 - コピー取引口座",
  gdzh_to_hyzh: "コピー取引口座 - 先物取引口座",
  ddcl: "処理中",
  cg: "成功",
  // dialog
  zchz: "資産振替",
  ljhz: "今すぐ振替",
  cong: "から",
  dao: "まで",
  qtzh: "他の口座",
  qxzbz: "通貨を選択してください",
  qsrsl: "数量を入力してください",
  khz: "振替可能:",
  ye: "残高:",
  hzcg: "振替成功",
  // h5
  zcgl: "資産概要",
  xrzx: "新人限定",
  zzc: "総資産",
  jryk: "本日の利益/損失",
  zgjz: "最大3200 USDTの新人特典がお待ちしています",
  zhrj: "口座に資金を入金",
  xzrjfs:
    "入金後、仮想通貨を購入することができます。実際の状況に応じて入金方法を選択できます",
  czszhb: "仮想通貨を入金",
  yyydszhb:
    "他のプラットフォームで保有している仮想通貨をBiking口座に入金できます。",
  czfb: "法定通貨を入金",
  czzhz:
    "お持ちの法定通貨をBiking口座に入金できます。銀行口座、振込などさまざまな支払い方法をサポートしています",
  maibi: "コイン購入",
  tgdsfmb: "銀行口座、P2P、第三者などの方法で仮想通貨を購入できます",
  yqyl: "紹介特典",
  yqfy: "友達を紹介して20%のコミッションを受け取る",
  cxzzn: "初心者ガイド",
  czzh: "Biking口座を作成",
  hdxrj: "100 USDTの新人ボーナスを受け取る",
  ck: "入金",
  tzndzh: "口座に投資し、旅を始めましょう。さまざまな支払い方法を選択できます",
  wcsfrz: "本人確認（KYC）を行う",
  hgzh: "本人確認（KYC）を行い、認証アカウントになる",
  ksjy: "取引を始める",
  tsgd: "売買、購入、またはコピー取引を行い、さらに探索しましょう",
  ksndlc: "旅を始める",
  kjydjmhb: "取引可能な仮想通貨",
  jmhb: "仮想通貨の総価値は1228.485億ドルです。",
  zengjin: "贈り物",
  lc: "財務管理",
  mb: "コインを購入",
  lsjl: "歴史",
  zclb: "資産リスト",
  shaixuan: "フィルター",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/property/ja_JP.js